import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

// Final results: score per section (out of its weight) and the total band.
const ScoreSummary = ({ scores }) => {
  if (!scores) return null;

  return (
    <div className={styles.summaryGrid}>
      <div className={cx(styles.summaryCard, styles.summaryTotal)}>
        <div className={ui.fieldLabel}>Total score</div>
        <div className={styles.summaryValue}>{scores.total} / 100</div>
        {scores.band && <Badge tone="blue">{scores.band}</Badge>}
      </div>

      {scores.sections.map((s) => (
        <div key={s.key} className={styles.summaryCard}>
          <div className={ui.fieldLabel}>{s.title}</div>
          <div className={styles.summaryValue}>
            {s.score} <span className={ui.muted}>/ {s.weight}</span>
          </div>
          <div className={styles.progress}>
            <div
              className={styles.progressFill}
              style={{ width: `${Math.min(100, (s.score / s.weight) * 100)}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScoreSummary;
